// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { Tenant } from 'util/Types';
import styles from './SelectTenantCard.module.scss';

const SelectTenantCard: React.FC<{
  tenant: Tenant;
  onSelectTenant: (Tenant: Tenant) => void;
  displaySectionFloor?: boolean;
}> = ({ tenant, onSelectTenant, displaySectionFloor }) => {
  return (
    <div
      key={tenant.id}
      className={styles.tenantItem}
      onClick={() => onSelectTenant(tenant)}
    >
      <p title={tenant.name}>{tenant.name}</p>

      {displaySectionFloor && (
        <div className={styles.sectionFloor}>
          <p>{`${tenant.section ? tenant.section.name : '-'} / ${
            tenant.floor ? tenant.floor.name : '-'
          }`}</p>
        </div>
      )}
    </div>
  );
};

export default SelectTenantCard;
